import React, { useEffect } from "react";
import { normalizeUrl } from "../utils/utils";
import { getOrganizationSettings } from "../utils/storage";

export default function StatusPill({ status }) {

    useEffect(() => {

        console.log(status, 'the main status');


    }, [status])


    return (
        <span
            className={`status-badge ${status.toLowerCase() === "completed" || status.toLowerCase() === "successful"
                ? "status-success"
                : status.toLowerCase() === "pending"
                    ? "status-warning"
                    : status.toLowerCase() === "failed"
                        ? "status-danger"
                        : "status-info"
                }`}
        >
            <span
                className={`w-2 h-2 rounded-full mr-2 ${status.toLowerCase() === "completed" || status.toLowerCase() === "successful"
                    ? "bg-success-500"
                    : status.toLowerCase() === "pending"
                        ? "bg-warning-500"
                        : status.toLowerCase() === "failed"
                            ? "bg-danger-500"
                            : "bg-primary-500"
                    }`}
            ></span>
            {status}
        </span>
    );
}
